import type { ModelSchema } from '@ember-data/store/types';

import type { RecordData } from 'webapp-types';

import BoardSerializer from 'webapp/serializers/board';

export default class BoardPreviewSerializer extends BoardSerializer {
	override normalize(
		typeClass: ModelSchema,
		json: RecordData.BoardPreview.Raw | RecordData.BoardPreview.Serialized,
		prop: string | undefined,
	) {
		// if (!json.boardId) {
		// 	json.boardId = json.id;
		// }
		// json.id = json.previewHash; // used only on the public datawalls page to pre-fill store with fake previews before real data comes in

		return super.normalize(typeClass, json, prop);
	}
}
